export const footerFallbackRu = {
  id: 1,
  locale: 'ru',
  links: [
    {
      id: 4,
      title: 'RuStore магазин приложений',
      elements: [
        {
          id: 1,
          title: 'О RuStore',
          href: 'https://www.rustore.ru/help/users/about-rustore/',
          isTargetBlank: true,
        },
        {
          id: 2,
          title: 'RuStore для TV',
          href: 'https://www.rustore.ru/tv',
          isTargetBlank: true,
        },
        {
          id: 3,
          title: 'RuStore для телефона',
          href: 'https://www.rustore.ru/instruction',
          isTargetBlank: false,
        },
        {
          id: 95,
          title: 'RuStore для ОС Аврора',
          href: 'https://www.rustore.ru/osaurora',
          isTargetBlank: true,
        },
        {
          id: 4,
          title: 'Медиа-кит (для СМИ и блогеров)',
          href: 'https://www.rustore.ru/media-kit',
          isTargetBlank: true,
        },
        {
          id: 5,
          title: 'Нашли уязвимость? (программа Bug Bounty)',
          href: 'https://bugbounty.vk.company',
          isTargetBlank: true,
        },
        {
          id: 6,
          title: 'Пользовательское соглашение',
          href: 'https://www.rustore.ru/help/legal/terms-of-use/',
          isTargetBlank: true,
        },
        {
          id: 7,
          title: 'Конфиденциальность для пользователей',
          href: 'https://www.rustore.ru/help/legal/privacy-policy-users/',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 1,
      title: 'Помощь',
      elements: [
        {
          id: 9,
          title: 'Установка RuStore на TV',
          href: 'https://www.rustore.ru/help/users/start/install-on-tv/install-apk-on-tv/',
          isTargetBlank: true,
        },
        {
          id: 8,
          title: 'Установка RuStore на телефон',
          href: 'https://www.rustore.ru/help/users/start/app-install/',
          isTargetBlank: true,
        },
        {
          id: 11,
          title: 'Помощь пользователям RuStore',
          href: 'https://www.rustore.ru/help/users/start/',
          isTargetBlank: true,
        },
        {
          id: 10,
          title: 'Покупки и возвраты',
          href: 'https://www.rustore.ru/help/users/purchases-and-returns/',
          isTargetBlank: true,
        },
        {
          id: 12,
          title: 'Авторизация в RuStore (SBER ID, VK ID)',
          href: 'https://www.rustore.ru/help/users/authorization/',
          isTargetBlank: true,
        },
        {
          id: 13,
          title: 'Сбой обновления приложений',
          href: 'https://www.rustore.ru/help/users/app-management/update-failure/',
          isTargetBlank: true,
        },
        {
          id: 15,
          title: 'Родительский контроль',
          href: 'https://www.rustore.ru/parental-control',
          isTargetBlank: true,
        },
        {
          id: 14,
          title: 'Как написать отзыв к приложению',
          href: 'https://www.rustore.ru/help/users/app-management/app-review/',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 3,
      title: 'Разработчикам',
      elements: [
        {
          id: 16,
          title: 'Зарабатывать с RuStore',
          href: 'https://www.rustore.ru/help/developers/monetization/',
          isTargetBlank: true,
        },
        {
          id: 17,
          title: 'Стать разработчиком',
          href: 'https://www.rustore.ru/help/developers/',
          isTargetBlank: true,
        },
        {
          id: 18,
          title: 'Доступ к RuStore Консоль',
          href: 'https://dev.rustore.ru/',
          isTargetBlank: true,
        },
        {
          id: 19,
          title: 'RuStore SDK (документация)',
          href: 'https://www.rustore.ru/help/sdk/',
          isTargetBlank: true,
        },
        {
          id: 21,
          title: 'Регистрация иностранной компании',
          href: 'https://www.rustore.ru/help/developers/developer-account/registration-developer/foreign-company-developer-account/',
          isTargetBlank: true,
        },
        {
          id: 20,
          title: 'Соглашение о распространении',
          href: 'https://www.rustore.ru/help/legal/developers-agreement/',
          isTargetBlank: true,
        },
        {
          id: 24,
          title: 'Конфиденциальность для разработчиков',
          href: 'https://www.rustore.ru/help/legal/privacy-policy-developers/',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 9,
      title: 'Популярные категории',
      elements: [
        {
          id: 55,
          title: 'Игры для Android',
          href: 'https://www.rustore.ru/catalog/games',
          isTargetBlank: true,
        },
        {
          id: 56,
          title: 'Приложения банков',
          href: 'https://www.rustore.ru/catalog/finance',
          isTargetBlank: true,
        },
        {
          id: 57,
          title: 'Государственные',
          href: 'https://www.rustore.ru/catalog/state',
          isTargetBlank: true,
        },
        {
          id: 58,
          title: 'Родителям',
          href: 'https://www.rustore.ru/catalog/parenting',
          isTargetBlank: true,
        },
        {
          id: 59,
          title: 'Приложения для шопинга',
          href: 'https://www.rustore.ru/catalog/purchases',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 2,
      title: 'Блог',
      elements: [
        {
          id: 22,
          title: 'Обзоры игр и статьи о мобильных приложениях',
          href: '/prostore?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 144,
          title: '7 детских игр на Android',
          href: '/prostore/detskie-igry-na-android?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 142,
          title: '10 приложений для Android TV',
          href: '/prostore/10-prilozhenij-dlya-android-tv?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 143,
          title: '20 приложений для Москвы',
          href: '/prostore/prilozhenija-dlja-moskvichej?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 145,
          title: '8 мобильных игр про хомяков',
          href: '/prostore/vmesto-tysjachi-tapov-8-mobilnyh-igr-pro-homjakov?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 26,
          title: '10 приложений для детского телефона',
          href: '/prostore/10-prilozhenij-dlya-detskogo-telefona-interesno-i-bezopasno?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 146,
          title: '20 приложений для Санкт-Петербурга',
          href: '/prostore/prilozhenija-dlja-peterburzhcev?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 60,
          title: 'Как оплачивать покупки телефоном в 2024 году?',
          href: '/prostore/kak-polzovatsya-telefonom-vmesto-karty-beskontaktnye-platezhi-android?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 147,
          title: '10 самых полезных государственных сервисов',
          href: '/prostore/podborka-gosudarstvennyh-servisov?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 20,
      title: 'Подборки',
      elements: [
        {
          id: 130,
          title: 'Игровой набор',
          href: 'https://www.rustore.ru/catalog/featuring/abfbb9fb-1d3c-4234-86cb-798836967b29',
          isTargetBlank: true,
        },
        {
          id: 131,
          title: 'Финансы',
          href: 'https://www.rustore.ru/catalog/featuring/a5aa70f3-d3fd-472c-816b-9011ab6bfedc',
          isTargetBlank: true,
        },
        {
          id: 133,
          title: 'На каждый день',
          href: 'https://www.rustore.ru/catalog/featuring/9d90c399-7702-4b83-aa2e-0b03d626ebe9',
          isTargetBlank: true,
        },
        {
          id: 140,
          title: 'Полезные инструменты',
          href: 'https://www.rustore.ru/catalog/featuring/7d5a4980-616d-40ae-b5f2-9a49db6028ad',
          isTargetBlank: true,
        },
        {
          id: 132,
          title: 'Новинки недели',
          href: 'https://www.rustore.ru/catalog/featuring/7341999c-1bde-44a9-83c2-434eca91bacc',
          isTargetBlank: true,
        },
        {
          id: 134,
          title: 'Высокий рейтинг',
          href: 'https://www.rustore.ru/catalog/featuring/6d0c1915-bb95-4408-ab78-3942fc84199a',
          isTargetBlank: true,
        },
      ],
    },
  ],
  leftSideContent: {
    id: 1,
    copyright: '© VK 2022—2024 RuStore',
    qrCodeDescription:
      'Наведи камеру \u003Cbr /\u003E для загрузки RuStore \u003Cbr /\u003E и следуй \u003Ca href="https://www.rustore.ru/instruction"\u003Eинструкции\u003C/a\u003E',
    rustoreLogoHref: {
      id: 708,
      url: 'https://static.rustore.ru/rustore-strapi/logo_color_30_px_57aa562dd4.svg',
    },
    qrCodeHref: {
      id: 712,
      url: 'https://static.rustore.ru/rustore-strapi/qr_code_d67c9a63db.svg',
    },
    devLandingSocialLinks: [
      {
        id: 8,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 710,
          url: 'https://static.rustore.ru/rustore-strapi/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 9,
        href: 'https://t.me/rustoredev',
        isTargetBlank: true,
        logoHref: {
          id: 709,
          url: 'https://static.rustore.ru/rustore-strapi/TG_Icon_0cfdd8ff22.svg',
        },
      },
    ],
  },
};

export const footerFallbackEn = {
  id: 1,
  locale: 'en',
  links: [
    {
      id: 8,
      title: 'RuStore',
      elements: [
        {
          id: 33,
          title: 'About RuStore',
          href: 'https://www.rustore.ru/help/en/users/about-rustore/',
          isTargetBlank: true,
        },
        {
          id: 29,
          title: 'RuStore for TV',
          href: 'https://www.rustore.ru/tv',
          isTargetBlank: false,
        },
        {
          id: 28,
          title: 'RuStore for smartphones',
          href: 'https://www.rustore.ru/instruction',
          isTargetBlank: false,
        },
        {
          id: 31,
          title: 'Media kit',
          href: 'https://www.rustore.ru/media-kit',
          isTargetBlank: false,
        },
        {
          id: 30,
          title: 'Report a bug',
          href: 'https://bugbounty.standoff365.com/programs/rustore_vk',
          isTargetBlank: true,
        },
        {
          id: 32,
          title: 'Terms of use',
          href: 'https://www.rustore.ru/help/en/legal/terms-of-use/',
          isTargetBlank: true,
        },
        {
          id: 35,
          title: 'Privacy policy (users)',
          href: 'https://www.rustore.ru/help/en/legal/privacy-policy-users/',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 6,
      title: 'Help',
      elements: [
        {
          id: 34,
          title: 'Install RuStore on TV ',
          href: 'https://www.rustore.ru/help/en/users/start/install-on-tv/install-apk-on-tv/',
          isTargetBlank: true,
        },
        {
          id: 36,
          title: 'Install RuStore on smartphone',
          href: 'https://www.rustore.ru/help/users/start/app-install/',
          isTargetBlank: true,
        },
        {
          id: 37,
          title: 'Get started with RuStore',
          href: 'https://www.rustore.ru/help/en/users/start/',
          isTargetBlank: true,
        },
        {
          id: 39,
          title: 'Purchases and returns',
          href: 'https://www.rustore.ru/help/en/users/purchases-and-returns/',
          isTargetBlank: true,
        },
        {
          id: 38,
          title: 'Sign in to RuStore (SBER ID, VK ID)',
          href: 'https://www.rustore.ru/help/users/authorization',
          isTargetBlank: true,
        },
        {
          id: 41,
          title: 'Troubleshooting update issues ',
          href: 'https://www.rustore.ru/help/users/app-management/update-failure/',
          isTargetBlank: true,
        },
        {
          id: 40,
          title: 'Parental control',
          href: 'https://help.rustore.ru/rustore/main_info/start/parental_control',
          isTargetBlank: true,
        },
        {
          id: 42,
          title: 'How to leave app review on RuStore ',
          href: 'https://www.rustore.ru/help/en/users/app-management/app-review',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 5,
      title: 'Developers',
      elements: [
        {
          id: 44,
          title: 'Enable monetization on RuStore',
          href: 'https://www.rustore.ru/help/en/developers/monetization/',
          isTargetBlank: true,
        },
        {
          id: 43,
          title: 'Create developer account',
          href: 'https://www.rustore.ru/help/en/developers/',
          isTargetBlank: true,
        },
        {
          id: 48,
          title: 'Open RuStore Console',
          href: 'https://dev.rustore.ru/en',
          isTargetBlank: false,
        },
        {
          id: 47,
          title: 'RuStore SDK Documentation',
          href: 'https://www.rustore.ru/help/en',
          isTargetBlank: true,
        },
        {
          id: 45,
          title: 'Create foreign company account ',
          href: 'https://www.rustore.ru/help/en/developers/developer-account/registration-developer/foreign-company-developer-account',
          isTargetBlank: true,
        },
        {
          id: 46,
          title: 'Software distribution agreement ',
          href: 'https://www.rustore.ru/help/en/legal/developers-agreement/',
          isTargetBlank: true,
        },
        {
          id: 49,
          title: 'Privacy policy (developers) ',
          href: 'https://www.rustore.ru/help/en/legal/privacy-policy-developers/',
          isTargetBlank: true,
        },
      ],
    },
  ],
  leftSideContent: {
    id: 2,
    copyright: '© VK 2022—2024 Download from RuStore.',
    qrCodeDescription:
      'Point your camera to download RuStore and follow the \u003Ca href="https://rustore.ru/instruction"\u003Einstructions\u003C/a\u003E',
    rustoreLogoHref: {
      id: 708,
      url: 'https://static.rustore.ru/rustore-strapi/logo_color_30_px_57aa562dd4.svg',
    },
    qrCodeHref: {
      id: 712,
      url: 'https://static.rustore.ru/rustore-strapi/qr_code_d67c9a63db.svg',
    },
    devLandingSocialLinks: [
      {
        id: 8,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 710,
          url: 'https://static.rustore.ru/rustore-strapi/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 9,
        href: 'https://t.me/rustoredev',
        isTargetBlank: true,
        logoHref: {
          id: 709,
          url: 'https://static.rustore.ru/rustore-strapi/TG_Icon_0cfdd8ff22.svg',
        },
      },
    ],
  },
};

export const footerFallbackZh = {
  id: 1,
  locale: 'zh',
  links: [
    {
      id: 10,
      title: 'RuStore 应用商店',
      elements: [
        {
          id: 66,
          title: '关于RuStore',
          href: 'http://rustore.ru/help/zh',
          isTargetBlank: true,
        },
        {
          id: 65,
          title: 'RuStore 为电视',
          href: 'https://www.rustore.ru/tv',
          isTargetBlank: true,
        },
        {
          id: 61,
          title: 'RuStore 为手机',
          href: 'https://www.rustore.ru/instruction',
          isTargetBlank: false,
        },
        {
          id: 62,
          title: '媒体工具包 (为媒体与博主)',
          href: 'https://www.rustore.ru/media-kit',
          isTargetBlank: true,
        },
        {
          id: 63,
          title: '发现漏洞吗？(Bug Bounty项目)',
          href: 'https://bugbounty.vk.company',
          isTargetBlank: true,
        },
        {
          id: 64,
          title: '用户协议',
          href: 'http://rustore.ru/help/zh',
          isTargetBlank: true,
        },
        {
          id: 67,
          title: '用户隐私',
          href: 'http://rustore.ru/help/zh',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 11,
      title: '帮助',
      elements: [
        {
          id: 68,
          title: '在电视上安装RuStore',
          href: 'https://www.rustore.ru/help/en/users/start/install-on-tv/install-apk-on-tv/',
          isTargetBlank: true,
        },
        {
          id: 70,
          title: '在手机上安装RuStore',
          href: 'https://www.rustore.ru/help/en/users/start/app-install/',
          isTargetBlank: true,
        },
        {
          id: 69,
          title: 'RuStore用户帮助',
          href: 'https://www.rustore.ru/help/en/users/start/',
          isTargetBlank: true,
        },
        {
          id: 71,
          title: '购买与退款',
          href: 'https://www.rustore.ru/help/en/users/purchases-and-returns/',
          isTargetBlank: true,
        },
        {
          id: 72,
          title: 'RuStore授权 (SBER ID, VK ID)',
          href: 'https://www.rustore.ru/help/en/users/authorization/',
          isTargetBlank: true,
        },
        {
          id: 76,
          title: '应用程序更新失败',
          href: 'https://www.rustore.ru/help/en/users/app-management/update-failure/',
          isTargetBlank: true,
        },
        {
          id: 73,
          title: '家长控制',
          href: 'https://www.rustore.ru/help/en/users/start/parental-control/',
          isTargetBlank: true,
        },
        {
          id: 74,
          title: '如何为应用程序撰写评论',
          href: 'https://www.rustore.ru/help/en/users/app-management/app-review/',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 12,
      title: '为开发者',
      elements: [
        {
          id: 77,
          title: '通过RuStore赚钱',
          href: 'https://www.rustore.ru/help/en/developers/monetization/',
          isTargetBlank: true,
        },
        {
          id: 75,
          title: '成为开发者',
          href: 'https://www.rustore.ru/help/en/developers/',
          isTargetBlank: true,
        },
        {
          id: 78,
          title: '访问RuStore控制台',
          href: 'https://dev.rustore.ru/zh',
          isTargetBlank: true,
        },
        {
          id: 79,
          title: 'RuStore SDK（技术手册)',
          href: 'https://www.rustore.ru/help/en/sdk/',
          isTargetBlank: true,
        },
        {
          id: 80,
          title: '国外公司注册',
          href: 'https://www.rustore.ru/help/en/developers/developer-account/registration-developer/foreign-company-developer-account/',
          isTargetBlank: true,
        },
        {
          id: 81,
          title: '分销协议',
          href: 'https://www.rustore.ru/help/en/legal/developers-agreement/',
          isTargetBlank: true,
        },
        {
          id: 82,
          title: '开发者隐私',
          href: 'https://www.rustore.ru/help/en/legal/privacy-policy-developers/',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 13,
      title: '热门类别',
      elements: [
        {
          id: 83,
          title: '有用的',
          href: 'https://www.rustore.ru/prostore/',
          isTargetBlank: true,
        },
        {
          id: 84,
          title: 'Android游戏',
          href: 'https://www.rustore.ru/catalog/games',
          isTargetBlank: true,
        },
        {
          id: 85,
          title: '银行应用程序',
          href: 'https://www.rustore.ru/catalog/finance',
          isTargetBlank: true,
        },
        {
          id: 87,
          title: '国家应用程序',
          href: 'https://www.rustore.ru/catalog/state',
          isTargetBlank: true,
        },
        {
          id: 86,
          title: '购物应用程序',
          href: 'https://www.rustore.ru/catalog/purchases',
          isTargetBlank: true,
        },
        {
          id: 94,
          title: '为家长',
          href: 'https://www.rustore.ru/catalog/parenting',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 14,
      title: '有用的',
      elements: [
        {
          id: 92,
          title: 'Android优化：如何加速您的设备',
          href: 'https://www.rustore.ru/prostore/populyarnye-igry-vybor-redakcii?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 88,
          title: 'Android 游戏：玩家最受欢迎的应用',
          href: 'https://www.rustore.ru/prostore/10-prilozhenij-dlya-detskogo-telefona-interesno-i-bezopasno?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 93,
          title: 'Android 摄影：如何拍摄完美照片',
          href: 'https://www.rustore.ru/prostore/kak-skachat-prilozhenie-sberkids-na-android?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
        {
          id: 89,
          title: 'Android TV 指南：如何设置和使用',
          href: 'https://www.rustore.ru/prostore/kak-polzovatsya-telefonom-vmesto-karty-beskontaktnye-platezhi-android?mt_link_id=rpn0r1&rsm=1&mt_sub1=footer',
          isTargetBlank: true,
        },
      ],
    },
  ],
  leftSideContent: {
    id: 3,
    copyright: '© VK 2022—2024 RuStore',
    qrCodeDescription: '扫二维码下载RuStore, <br/> 按照指南操作',
    rustoreLogoHref: {
      id: 708,
      url: 'https://static.rustore.ru/rustore-strapi/logo_color_30_px_57aa562dd4.svg',
    },
    qrCodeHref: {
      id: 712,
      url: 'https://static.rustore.ru/rustore-strapi/qr_code_d67c9a63db.svg',
    },
    devLandingSocialLinks: [
      {
        id: 14,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 710,
          url: 'https://static.rustore.ru/rustore-strapi/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 13,
        href: 'https://t.me/rustoredev',
        isTargetBlank: true,
        logoHref: {
          id: 709,
          url: 'https://static.rustore.ru/rustore-strapi/TG_Icon_0cfdd8ff22.svg',
        },
      },
    ],
  },
};
